















import Vue from 'vue'
import QuestionAudio from '@/components/QuestionAudio.vue'

export default Vue.extend({
  name: "ImageArea",
  props: {
    imgSrc: String,
    audioSrc: String,
    titleText: String,
    type: String // "question" | "answer" | "info"
  },
  components: {
    QuestionAudio
  }
})
